<template>
    <div class="pt-2 px-4">
        <top-area :reservation="reservation"></top-area>
        <person-ticket-selector v-if="showTicketPicker" :reservation="reservation" :readOnly="getIsAddingReservation"></person-ticket-selector>

        <div class="bg-lightest radius-normal border-light my-3">
            <div class="col-sm-12 pt-3">
                <h5 class="w-100">Customer Details</h5>
                <customer-details :reservation="reservation"></customer-details>
            </div>
        </div>

        <div v-if="showBillinDetailsForm" class="bg-lightest radius-normal border-light mt-3">
            <div class="col-sm-12 pt-3">
                <h5 class="w-100">Billing Details</h5>
                <billing-details :reservation="reservation"></billing-details>
            </div>
        </div>

    </div>
</template>

<script>
import topArea from './Details/TopArea'
import {mapGetters} from 'vuex'
import PersonTicketSelector from './Details/PersonTicketSelector'
import CustomerDetails from './Details/CustomerDetails'
import BillingDetails from './Details/BillingDetails'
import { reservationsMixin } from '@/mixins/reservations'

export default {
    data: function() {
        return {

        }
    },
    mixins:[
        reservationsMixin
    ],
    props: {
        reservation: {
            type: Object
        },
    },
    computed: {
        ...mapGetters([
            'getIsAddingReservation'
        ]),
        showTicketPicker: function () {
            //dont show it is "Per Order" without participants - meaning that is just one ticket per order
            if(this.reservation.bookingGenderPrices.length == 1 && this.reservation.bookingGenderPrices[0].genderPriceType == 1 ){
                return false
            } else {
                return true
            }
        },
        showBillinDetailsForm: function () {
            // return true
            return this.selectedSellerAccessList? this.selectedSellerAccessList.channel.isInvoiceAutomatic : false
        }
    },
    methods: {
    },
    components: {
        topArea,
        PersonTicketSelector,
        CustomerDetails,
        BillingDetails
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Details.vue?75dc2ef7